/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreatePersonDismissedProjectNotificationMutationInput = {|
  projectId?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type CreatePersonDismissedProjectNotificationMutationVariables = {|
  input: CreatePersonDismissedProjectNotificationMutationInput
|};
export type CreatePersonDismissedProjectNotificationMutationResponse = {|
  +createPersonDismissedProjectNotificationMutation: ?{|
    +viewer: ?{|
      +personDismissedProjectNotificationIds: ?$ReadOnlyArray<?string>
    |}
  |}
|};
export type CreatePersonDismissedProjectNotificationMutation = {|
  variables: CreatePersonDismissedProjectNotificationMutationVariables,
  response: CreatePersonDismissedProjectNotificationMutationResponse,
|};
*/


/*
mutation CreatePersonDismissedProjectNotificationMutation(
  $input: CreatePersonDismissedProjectNotificationMutationInput!
) {
  createPersonDismissedProjectNotificationMutation(input: $input) {
    viewer {
      personDismissedProjectNotificationIds
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreatePersonDismissedProjectNotificationMutationInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "personDismissedProjectNotificationIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreatePersonDismissedProjectNotificationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreatePersonDismissedProjectNotificationMutationPayload",
        "kind": "LinkedField",
        "name": "createPersonDismissedProjectNotificationMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreatePersonDismissedProjectNotificationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreatePersonDismissedProjectNotificationMutationPayload",
        "kind": "LinkedField",
        "name": "createPersonDismissedProjectNotificationMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CreatePersonDismissedProjectNotificationMutation",
    "operationKind": "mutation",
    "text": "mutation CreatePersonDismissedProjectNotificationMutation(\n  $input: CreatePersonDismissedProjectNotificationMutationInput!\n) {\n  createPersonDismissedProjectNotificationMutation(input: $input) {\n    viewer {\n      personDismissedProjectNotificationIds\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '31e0f46ac06c6fccb95b339690234dbb';

module.exports = node;
